import React, { useState, useEffect, Suspense } from "react";
import {
  Container,
  FormControl,
  Stack,
  Typography,
  styled,
  Box,
  CircularProgress,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../constants/API";
import {
  Btn,
  CardBox,
  SaveBox,
  CardTitle,
  DetailsBox,
  FeatureBox,
  FeatureText,
  svgCode,
  CustomSelect,
  CustomMenuItem,
  CustomSelect2,
} from "./styles";
import Toaster from "../component/Toaster";
import Loader from "../component/Loading";
import pdfIcon from "../assets/pdf icon.png";
import webIcon from "../assets/web icon.svg";
import pdfWhite from "../assets/pdf white icon.png";
import webWhite from "../assets/web white icon.png";
import plusIcon from "../assets/plus icon.png";
import BreadCrumb from "../component/BreadCrumb";
import { CategoryDiscount } from "../constants/constants";
// import Cart from "./Cart";
import { Helmet } from "react-helmet";
import { AppContext } from "../App";
import { SiteId } from "../constants/constants";
import CartSkeletonLoading from "../pricing/CartSkeletonloading";
const Cart = React.lazy(() => import("../pricing/Cart"));
const GridBox = styled(Box)({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
  gap: "20px",
  margin: "50px 0",
});
const Title = styled(Typography)({
  fontFamily: "Poppins",
  fontWeight: 700,
  fontSize: "50px",
  textAlign: "center",
  color: "#1A1F22",
});
function Pricing() {
  const navigate = useNavigate();
  const currentExameId = localStorage.getItem("currentExameId");
  const { setCardItemNumber, toggle, showCart } = React.useContext(AppContext);
  const location = useLocation();
  const [duration, setDuration] = useState("1");
  const [duration2, setDuration2] = useState("1");
  const [duration3, setDuration3] = useState("1");
  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(false);
  const spiltPath = location.pathname.split("/");
  const ExamCode = spiltPath[spiltPath.length - 1];
  const [pricecardTitle, setPricecardTitle] = useState("");
  const [pricecardMetaDescription, setPricecardMetaDescription] = useState("");
  const [examId, setExamId] = useState(0);
  const [examCode, setExamCode] = useState("");
  const [examVendorName, setExamVendorName] = useState("");
  const [TotalExamQuestions, setTotalExamQuestions] = useState(0);
  const [QuestionforDownload, setQuestionforDownload] = useState(5);
  const [fetchedPricesFromGetPriceCard, setFetchedPricesFromGetPriceCard] =
    useState(false);
  const [isLoadingPrices, setIsLoadingPrices] = useState(true);
  const [alert, setAlert] = useState({
    open: false,
    type: "info",
    text: "",
  });
  const alertToggle = () => {
    setAlert({
      open: false,
      text: "",
      type: "info",
    });
  };
  const handleInput = (e) => {
    setDuration(e.target.value);
  };
  const handleInput2 = (e) => {
    setDuration2(e.target.value);
  };
  const handleInput3 = (e) => {
    setDuration3(e.target.value);
  };

  const handleAddToCart = (bundelType, dur, type) => {
    const shoppingItems = localStorage.getItem("shoppingItems");
    let prvItem = shoppingItems ? JSON.parse(shoppingItems) : [];
    const shoppingItemsbundle = localStorage.getItem("bundleshoppingItems");
    let prvItembundled = shoppingItemsbundle
      ? JSON.parse(shoppingItemsbundle)
      : [];
    if (prvItem.length) {
      const remaningItem = prvItem.filter((item) => item.examCode !== examCode);
      prvItem = remaningItem || [];
    }
    const basePrice = bundelType?.ExamPrice || 0;
    let price;
    switch (dur) {
      case "1":
        price = basePrice;
        break;
      case "2":
        price = basePrice + 20;
        break;
      case "3":
        price = basePrice + 30;
        break;
      default:
        price = basePrice;
    }
    prvItem.push({
      pack: bundelType,
      duration: dur,
      examCode: examCode,
      exameId: currentExameId,
      type: type,
      price: price,
    });
    prvItem.map((item, i) => {
      return (item.id = i + 1);
    });
    localStorage.setItem("shoppingItems", JSON.stringify(prvItem));
    //seting for bundle
    if (prvItembundled.length) {
      const remaningItem = prvItembundled.filter(
        (item) => item.examCode !== examCode
      );
      prvItembundled = remaningItem || [];
    }
    prvItembundled.push({
      pack: bundelType,
      duration: dur,
      examCode: examCode,
      exameId: currentExameId,
      type: type,
      vendor: examCode,
      price: price,
    });
    prvItembundled.map((item, i) => {
      return (item.id = i + 1);
    });
    localStorage.setItem("bundleshoppingItems", JSON.stringify(prvItembundled));
    setCardItemNumber(prvItem.length);
    toggle();
  };
  async function getPriceCardTitleMeta() {
    try {
      let { data } = await api.get(
        `/api/exam/GetPriceCardTitleMeta?ExamCode=${ExamCode}&SiteId=${SiteId}`
      );
      if (data.Items.length === 0) {
        // Handle invalid ExamCode (redirect to 404 or error handling)
        window.location.href = "/error";
        return;
      }

      if (data.Items[0].IsPreOrder) {
        const redirectUrl = `/${data.Items[0].ExamVendorName.toLowerCase()
          .replace(/\s/g, "-")
          .replace(/\+/g, "p")}/${ExamCode}`;
        navigate(redirectUrl);
        return;
      }
      let ExamId = data.Items[0].ExamId;
      let vendorName = data.Items[0].ExamVendorName;
      // console.log(vendorName, "vendor name");
      setExamCode(data.Items[0].ExamCode);
      setExamVendorName(vendorName);
      setExamId(ExamId);
      localStorage.setItem("currentExameId", ExamId);
      let ExamTotalQuestion = data.Items[0].TotalExamQuestions;
      setTotalExamQuestions(ExamTotalQuestion);
      let noOfQuestion = 5;
      if (ExamTotalQuestion <= 20) {
        noOfQuestion = 1;
      } else {
        noOfQuestion = 5;
      }
      setQuestionforDownload(noOfQuestion);
      let title = data.Items[0].pricecardTitle;
      let description = data.Items[0].pricecardMetaDescription;

      if (title) {
        // Remove HTML tags
        title = title
          .replace("{%exam-name%}", ExamCode.toUpperCase())
          .replace("{%exam-code%}", ExamCode.toUpperCase())
          .replace("{%category-name%}", vendorName)
          .replace(/<\/?[^>]+(>|$)/g, "")
          .replace(/&amp;/g, "&");
      } else {
        title = `Get ${ExamCode} Certification Practice Materials: PDFs & Interactive Tests`;
      }
      if (description) {
        description = description
          .replace(/&amp;/g, "&")
          .replace("{%exam-name%}", ExamCode.toUpperCase())
          .replace("{%exam-code%}", ExamCode.toUpperCase())
          .replace("{%category-name%}", vendorName)
          .replace(/<\/?[^>]+(>|$)/g, "");
      } else {
        description = `${ExamCode} Certification Practice Material Pricing: Explore our affordable PDF study guides and interactive online tests. Choose the package that best suits your preparation needs and budget. Unlock valuable resources to boost your confidence and increase your chances of passing the exam.`;
      }

      setPricecardTitle(title);
      setPricecardMetaDescription(description);

      // Store the prices from /api/exam/GetPriceCardTitleMeta
      const { PDFPrice, PractisePrice, BundlePrice } = data.Items[0];
      const pricecardTitleMetaPrices = [
        {
          ExamPrice: PDFPrice,
          Id: 1,
          PriceDesc: "PDF Printable (Q & A)",
          OrderLevel: 1,
          ExamDiscount: 0,
        },
        {
          ExamPrice: PractisePrice,
          Id: 2,
          PriceDesc: "Practice Test (Web Based)",
          OrderLevel: 2,
          ExamDiscount: 0,
        },
        {
          ExamPrice: BundlePrice,
          Id: 3,
          PriceDesc: "Bundle Pack",
          OrderLevel: 3,
          ExamDiscount: 0,
        },
      ];
      if (
        pricecardTitleMetaPrices.some(
          (price) => price.ExamPrice !== null && price.ExamPrice !== 0
        )
      ) {
        setCardData(pricecardTitleMetaPrices);
      } else if (!fetchedPricesFromGetPriceCard) {
        // Fetch prices from /api/exam/GetPriceCard if prices are not available from /api/exam/GetPriceCardTitleMeta
        const { data: priceCardData } = await api.get(`api/exam/GetPriceCard`);
        setCardData(priceCardData?.Items);
        // console.log(cardData, "when meta not av");
        setFetchedPricesFromGetPriceCard(true);
      }
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    getPriceCardTitleMeta();
  }, []);

  useEffect(() => {
    if (cardData.length > 0) {
      setDuration("1");
      setDuration2("1");
      setDuration3("1");
      setIsLoadingPrices(false);
    }
  }, [cardData]);

  const getPricingValue = (cardIndex, durationValue) => {
    if (isLoadingPrices) {
      return cardIndex === 2 ? (
        <CircularProgress size={80} sx={{ color: "#ffffff" }} />
      ) : (
        <CircularProgress size={80} sx={{ color: "#27b1bb" }} />
      );
    }
    const basePrice = cardData[cardIndex]?.ExamPrice || 0;
    switch (durationValue) {
      case "1":
        return `${basePrice}$`;
      case "2":
        return `${basePrice + 20}$`;
      case "3":
        return `${basePrice + 30}$`;
      default:
        return "";
    }
  };
  return (
    <>
      <Helmet>
        <title>{pricecardTitle}</title>
        <meta name="description" content={pricecardMetaDescription} />
        <link
          rel="canonical"
          href={`https://www.directcertify.com/${
            examVendorName
              .toLowerCase()
              .replace(/\s/g, "-") // replace all spaces with hyphens
              .replace(/\+/g, "p") // replace all plus signs with 'p'
          }/${ExamCode}`}
        />
      </Helmet>
      <Box sx={{ mt: 10 }}>
        {/* <Loader open={loading} /> */}
        <Toaster props={alert} onClose={alertToggle} />
        <Loader open={loading} />
        <Container sx={{ marginTop: { xs: "125px", md: "110px" } }}>
          <BreadCrumb text="Home" to="/" isLast={false} />
          <BreadCrumb
            text={examCode || ""}
            to={`/${
              examVendorName
                .toLowerCase()
                .replace(/\s/g, "-") // replace all spaces with hyphens
                .replace(/\+/g, "p") // replace all plus signs with 'p'
            }/${ExamCode}`}
            isLast={false}
          />
          <Title
            variant="h1"
            sx={{ fontSize: { xs: "24px", md: "28px" }, mt: 1 }}
          >
            {examCode || ""} Exam (Printable PDF, Practice Test, Bundle Pack)
          </Title>
          <GridBox
            sx={{
              px: { xs: "2%", sm: "3%", md: "5%" },
              marginTop: "20px !important",
            }}
          >
            <CardBox>
              <Stack spacing={2} alignItems="center" pt={1.7}>
                <Box sx={{ px: "15%" }}>
                  <CardTitle>PDF Printable (Q & A)</CardTitle>
                </Box>
                <img height="60px" src={pdfIcon} alt="pdf solo" />
                <Box sx={{ px: 1 }}>
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontFamily: "Poppins",
                      fontWeight: 800,
                      textAlign: "center",
                      color: "#27b1bb",
                    }}
                  >
                    Updates
                  </Typography>
                  <FormControl fullWidth size="small">
                    <CustomSelect value={duration} onChange={handleInput}>
                      <CustomMenuItem value="1">3 Months</CustomMenuItem>
                      <CustomMenuItem value="2">6 Months</CustomMenuItem>
                      <CustomMenuItem value="3">9 Months</CustomMenuItem>
                    </CustomSelect>
                  </FormControl>
                </Box>
                <Typography
                  sx={{
                    fontSize: "80px",
                    fontFamily: "Poppins",
                    fontWeight: 800,
                    textAlign: "center",
                    color: "#27b1bb",
                  }}
                >
                  {getPricingValue(0, duration)}
                </Typography>
                <Stack
                  width="100%"
                  direction="row"
                  justifyContent="space-evenly"
                  sx={{ marginTop: "8px !important" }}
                >
                  <Btn
                    variant="contained"
                    sx={{
                      background: "#FFD500 !important",
                      filter: "drop-shadow(0px 4px 0px #CFAD00)",
                    }}
                    disabled={isLoadingPrices}
                    onClick={() =>
                      handleAddToCart(cardData[0], duration, "PDF")
                    }
                  >
                    Add To Cart
                  </Btn>
                </Stack>
                <DetailsBox>
                  <FeatureBox>
                    <FeatureText>Up-to-date</FeatureText>
                  </FeatureBox>
                  <FeatureBox>
                    <FeatureText>Print Friendly</FeatureText>
                  </FeatureBox>
                  <FeatureBox>
                    <FeatureText>3-Months free updates</FeatureText>
                  </FeatureBox>
                  <FeatureBox>
                    <FeatureText>
                      {TotalExamQuestions} Exam Questions
                    </FeatureText>
                  </FeatureBox>
                </DetailsBox>
              </Stack>
            </CardBox>
            <CardBox>
              <Stack spacing={2} alignItems="center" pt={1.7}>
                <Stack alignItems="center" px="15%">
                  <CardTitle>Practice Test (Web Based)</CardTitle>
                  <img height="80px" src={webIcon} alt="web-based solo" />
                </Stack>
                <Box sx={{ px: 1 }}>
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontFamily: "Poppins",
                      fontWeight: 800,
                      textAlign: "center",
                      color: "#27b1bb",
                    }}
                  >
                    Updates
                  </Typography>
                  <FormControl fullWidth size="small">
                    <CustomSelect value={duration2} onChange={handleInput2}>
                      <CustomMenuItem value="1">3 Months</CustomMenuItem>
                      <CustomMenuItem value="2">6 Months</CustomMenuItem>
                      <CustomMenuItem value="3">9 Months</CustomMenuItem>
                    </CustomSelect>
                  </FormControl>
                </Box>
                <Typography
                  sx={{
                    fontSize: "80px",
                    fontFamily: "Poppins",
                    fontWeight: 800,
                    textAlign: "center",
                    color: "#27b1bb",
                  }}
                >
                  {getPricingValue(1, duration2)}
                </Typography>
                <Stack
                  width="100%"
                  direction="row"
                  justifyContent="space-evenly"
                  sx={{ marginTop: "8px !important" }}
                >
                  <Btn
                    variant="contained"
                    sx={{
                      background: "#FFD500 !important",
                      filter: "drop-shadow(0px 4px 0px #CFAD00)",
                    }}
                    disabled={isLoadingPrices}
                    onClick={() =>
                      handleAddToCart(cardData[1], duration2, "WEB BASED")
                    }
                  >
                    Add To Cart
                  </Btn>
                </Stack>
                <DetailsBox>
                  <FeatureBox>
                    <FeatureText>Up-to-date</FeatureText>
                  </FeatureBox>
                  <FeatureBox>
                    <FeatureText>Browser Friendly</FeatureText>
                  </FeatureBox>
                  <FeatureBox>
                    <FeatureText>3-Months free updates</FeatureText>
                  </FeatureBox>
                  <FeatureBox>
                    <FeatureText>
                      {TotalExamQuestions} Exam Questions
                    </FeatureText>
                  </FeatureBox>
                </DetailsBox>
              </Stack>
            </CardBox>
            <CardBox
              sx={{
                background: "#27B1BB",
                backgroundImage: `url("data:image/svg+xml,${encodeURIComponent(
                  svgCode
                )}")`,
              }}
            >
              <Stack spacing={2} alignItems="center" pt={1.7}>
                <Stack alignItems="center" px="15%">
                  <CardTitle sx={{ color: "#FFFFFF" }}>Bundle Pack</CardTitle>
                  <SaveBox>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontFamily: "Poppins",
                        fontWeight: 700,
                        color: "#27B1BB",
                      }}
                    >
                      {`Save ${CategoryDiscount}%`}
                    </Typography>
                  </SaveBox>
                </Stack>
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                >
                  <img height="60px" src={pdfWhite} alt="pdf bundlepack" />
                  <img height="40px" src={plusIcon} alt="plus icon" />
                  <img height="80px" src={webWhite} alt="webbased bundlepack" />
                </Stack>
                <Box sx={{ px: 1 }}>
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontFamily: "Poppins",
                      fontWeight: 800,
                      textAlign: "center",
                      color: "#ffffff",
                    }}
                  >
                    Updates
                  </Typography>
                  <FormControl fullWidth size="small">
                    <CustomSelect2 value={duration3} onChange={handleInput3}>
                      <CustomMenuItem value="1">3 Months</CustomMenuItem>
                      <CustomMenuItem value="2">6 Months</CustomMenuItem>
                      <CustomMenuItem value="3">9 Months</CustomMenuItem>
                    </CustomSelect2>
                  </FormControl>
                </Box>
                <Typography
                  sx={{
                    fontSize: "80px",
                    fontFamily: "Poppins",
                    fontWeight: 800,
                    textAlign: "center",
                    color: "#ffffff",
                  }}
                >
                  {getPricingValue(2, duration3)}
                </Typography>
                <Stack
                  width="100%"
                  direction="row"
                  justifyContent="center"
                  sx={{ marginTop: "8px !important" }}
                >
                  <Btn
                    variant="contained"
                    sx={{
                      background: "#FFD500 !important",
                      filter: "drop-shadow(0px 4px 0px #CFAD00)",
                    }}
                    disabled={isLoadingPrices}
                    onClick={() =>
                      handleAddToCart(cardData[2], duration3, "BUNDLE PACK")
                    }
                  >
                    Add To Cart
                  </Btn>
                </Stack>
                <DetailsBox sx={{ background: "#FFFFFF" }}>
                  <FeatureBox sx={{ border: "1px solid #27B1BB" }}>
                    <FeatureText>Up-to-date</FeatureText>
                  </FeatureBox>
                  <FeatureBox sx={{ border: "1px solid #27B1BB" }}>
                    <FeatureText>Browser Friendly</FeatureText>
                  </FeatureBox>
                  <FeatureBox sx={{ border: "1px solid #27B1BB" }}>
                    <FeatureText>3-Months free updates</FeatureText>
                  </FeatureBox>
                  <FeatureBox sx={{ border: "1px solid #27B1BB" }}>
                    <FeatureText>
                      {TotalExamQuestions} Exam Questions
                    </FeatureText>
                  </FeatureBox>
                </DetailsBox>
              </Stack>
            </CardBox>
          </GridBox>
        </Container>
        <Stack width="100%" justifyContent="flex-end">
          {showCart && (
            <Suspense fallback={<CartSkeletonLoading />}>
              <Cart open={showCart} onClose={toggle} />
            </Suspense>
          )}
        </Stack>
      </Box>
    </>
  );
}
export default Pricing;
